<template>
  <div class="home-container">
    <div class="home-content">
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item
                label="公告名称"
                prop="title"
                label-width="100px"
                style="width: 80%"
              >
                <el-input
                  v-model="searchForm.title"
                  placeholder="请输入公告名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="公告状态"
                label-width="100px"
                style="width: 80%"
              >
                <el-select clearable filterable v-model="searchForm.status">
                  <el-option label="开启" :value="1"></el-option>
                  <el-option label="关闭" :value="-1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-button
                size="small"
                @click="onLoad(1)"
                type="primary"
                icon="el-icon-search"
                style="width: 90px"
                >搜索</el-button
              >
              <el-button
                size="small"
                @click="restSearch"
                type="danger"
                style="width: 90px"
                >重置</el-button
              >
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="margin: 20px">
        <el-button
          size="small"
          plain
          type="primary"
          icon="el-icon-plus"
          @click="addCharacter"
          style="width: 90px"
          >新增</el-button
        >
      </div>

      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        
        <el-table-column prop="id" label="公告id" align="center">
        </el-table-column> 
        <el-table-column prop="sort" label="排序" align="center">
        </el-table-column>       
        <el-table-column prop="img" label="公告图片" align="center" width="150">
          <template slot-scope="scope">
            <img :src="scope.row.img" width="120" />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="公告名称" align="center">
        </el-table-column>
        <el-table-column prop="updateTime" label="公告时间" align="center">
        </el-table-column>        
        <el-table-column prop="isRecommend" label="是否推荐至首页" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isRecommend"
              @change="updataStatus(scope.row)"
              :active-value="1" :inactive-value="-1"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="isUrgent" label="紧急标签状态" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.isUrgent"
              @change="updataStatus1(scope.row)"
              :active-value="1" :inactive-value="-1"
            ></el-switch>
          </template>
        </el-table-column>  
        <el-table-column prop="status" label="公告状态" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.status"
              @change="updataStatus2(scope.row)"
              :active-value="1"
              :inactive-value="-1"
            ></el-switch>
          </template>
        </el-table-column>          
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <!-- <el-button
              type="text"
              size="small"
              @click="sendNotice(scope.row)"
              >发送通知</el-button
            >             -->
            <el-button
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >修改</el-button
            >

            <el-button @click="del(scope.row)" type="text" size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog :title="modalTitle" :visible.sync="isAddModal" width="50%" @close="close">
        <el-form
          ref="form"
          :model="addData"
          label-width="120px"
          :rules="addDataRules"
          label-position="center"
        >
          <el-form-item label="排序" prop="sort">
            <el-input-number 
              v-model="addData.sort" 
              :precision="0" 
              :step="1" 
              :min="1" 
              placeholder="请输入排序"
              controls-position="right"
              @change="$refs.form.validateField('sort')"
              @blur="$refs.form.validateField('sort')">
            </el-input-number>
          </el-form-item>
          <el-row>
            <el-col :span="24">
              <el-form-item label="公告图片" prop="img">
                <upload
                  :url.sync="addData.img"
                  :src="addData.img"
                  type="img"
                  width="900"
                  height="383"
                ></upload>
                <div style="color: red">*(建议尺寸900px * 383px)）</div>
              </el-form-item>
            </el-col>
          </el-row>    
          <el-row>
            <el-col :span="24">
              <el-form-item label="公告名称" prop="title">
                <el-input placeholder="请输入公告名称" maxlength="100" v-model="addData.title"></el-input>
              </el-form-item>
            </el-col>
          </el-row>  
          <el-row>
            <el-col :span="24">
              <el-form-item label="简介" prop="intro">
                <el-input placeholder="请输入简介" maxlength="255" v-model="addData.intro"></el-input>
              </el-form-item>
            </el-col>
          </el-row>  
          <el-row>
            <el-col :span="24">
            <el-form-item label="公告内容" prop="content">
              <ueditor v-model="addData.content"></ueditor>
            </el-form-item>  
            </el-col>
          </el-row>        
          <el-row>
            <el-col :span="24">
              <el-form-item label="是否推荐至首页" prop="isRecommend">
                <el-switch v-model="addData.isRecommend" :active-value="1" :inactive-value="-1"></el-switch>
              </el-form-item>  
            </el-col>
          </el-row>   
          <el-row>
            <el-col :span="24">
              <el-form-item label="紧急状态标签" prop="isUrgent">
                <el-switch v-model="addData.isUrgent" :active-value="1" :inactive-value="-1"></el-switch>
              </el-form-item>  
            </el-col>
          </el-row>   
          <el-row>
            <el-col :span="24">
              <el-form-item label="公告状态" prop="status">
                <el-switch v-model="addData.status" :active-value="1" :inactive-value="-1"></el-switch>
              </el-form-item>  
            </el-col>
          </el-row>   
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" :loading="btnLoading"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <send :index="2" @sendSubmit="sendSubmit" @isShowSend="sendFlags = false" v-if="sendFlags"></send>
    </div>
  </div>
</template>

<script>
import upload from "../../components/upload";
import ueditor from "../../components/ueditor"
import send from "../../components/send"
export default {
  components: {
    upload,
    ueditor,
    send
  },
  data() {
    return {
      searchForm: {
        site: "",
      },
      checkedStr: [], //选中的名称
      checkedIds: [], //选中的id
      isShowTrue: false, //是否显示二级树
      defaultProps: {
        children: "children",
        value: "id",
        label: "name",
      },
      houseFlag: true,
      modalTitle: "新增",
      props: {
        multiple: true,
        value: "id",
        label: "name",
        checkStrictly: true,
      },
      muneListData: [], //菜单信息
      tableData: [],
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      addData: {
        id: "",
        img:"",
        title:"",
        intro:"",
        content:""
      },
      addDataRules: {
        // img: [{ required: true, message: "请上传banner", trigger: "blur" }],
        sort: [{ required: true, message: "请输入排序", trigger: "blur" }],
        intro: [{ required: true, message: "请输入简介", trigger: "blur" }],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入内容", trigger: "blur" }]
      },
      isShowloading: false, //数据加载
      isAddModal: false, //新增模态框
      btnLoading: false, //提交按钮加载
      sendFlags:false,   
    };
  },
  created() {},
  mounted() {
    this.onLoad();
  },
  methods: {   
    sendSubmit(data){
      data.entityId = this.orderId
      this.$Apis.sendNotice(data).then(res=>{
        if(res.code == 200){
          this.$message.success('发送成功')
          this.sendFlags = false 
        }else{
          this.$message.warning(res.code)
        }
      })
    },
    sendNotice(row){
      this.orderId = row.id
      this.sendFlags = true
    },
    // 推荐
    updataStatus(row) {
      console.log(row)
      if(!row.img && row.isRecommend == 1){
        this.$message.warning('请先上传图片')
        row.isRecommend = -1
        return
      }
      let data = {
        id:row.id,
        isRecommend:row.isRecommend
      }
      
      this.$Apis.noticeRecommend(data).then((res) => {
        if (res.code == 200) {
          this.onLoad();
          this.$message.success("操作成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },    
    // 紧急
    updataStatus1(row) {
      let data = {
        id:row.id,
        isUrgent:row.isUrgent
      }
      this.$Apis.noticeUrgent(data).then((res) => {
        if (res.code == 200) {
          this.onLoad();
          this.$message.success("操作成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },  
    // 启用禁用
    updataStatus2(row) {
      let data = {
        id:row.id,
        status:row.status
      }
      this.$Apis.noticeUpdateStatus(data).then((res) => {
        if (res.code == 200) {
          this.onLoad();
          this.$message.success("操作成功");
        } else {
          this.$message.warning(res.msg);
        }
      });
    },  
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    // 新增角色
    addCharacter() {
      for (let item in this.addData) {
        this.addData[item] = "";
      }
      this.modalTitle = "新增"; 
      this.isAddModal = true;
    },
    close(){
      this.$refs.form.resetFields();
      this.isAddModal = false;
      for (let item in this.addData) {
        this.addData[item] = "";
      }
    },
    // 修改角色
    updataCharacter(row) {
      this.addData = JSON.parse(JSON.stringify(row));
      this.isAddModal = true;
    },
    //删除角色
    del(row) {
      let id = row.id;
      this.$confirm("您确定要删除吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$Apis.noticeDel({ id }).then((res) => {
          if (res.code == 200) {
            this.onLoad();
            this.$message.success("删除成功");
          } else {
            this.$message.warning(res.msg);
          }
        });
      });
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if(this.addData.isRecommend == 1 && !this.addData.img){
            this.$message.warning('请先上传图片')
            return
          }
          this.btnLoading = true;
          var data = {
            id: this.addData.id || "",
            img: this.addData.img,
            title: this.addData.title,
            intro: this.addData.intro,
            content: this.addData.content,
            isRecommend: this.addData.isRecommend,
            isUrgent: this.addData.isUrgent,
            status: this.addData.status,
            sort: this.addData.sort
          };
          this.$Apis.noticeAddUp(data).then((res) => {
            this.btnLoading = false;
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },

    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad()
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad()
    },
    onLoad() {
      this.isShowloading = true;
      this.$Apis.houseAllList().then(res=>{
        if(res.code == 200){
          this.ridgepoleList = res.data
        }
      })         
      let page = {
        size: this.pageSize,
        current: this.currentPage,
        ...this.searchForm
      };
      this.$Apis.noticeList(page).then((res) => {
        this.isShowloading = false;
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;

          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        }
      });
    },
  },
};
</script>

<style>
.home-container {
  padding: 10px;
  padding-top: 5px;
}
.home-content {
  padding: 10px;
  border-radius: 5px;
  background: #fff;
}
.tree {
  margin-top: 10px;
  width: 300px;
  z-index: 999;
  background-color: #fff;
  padding: 20px;
  height: 200px;
  overflow: auto;
  border: 1px solid #eee;
  border-radius: 5px;
}
</style>